var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('el-alert',{attrs:{"title":"Sem Conexão com o servidor","type":"error","description":"Verifique sua conexão com a internet, caso você tenha conexão, contate o administrador do sistema.","show-icon":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70dafac7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NoConnection.vue
// module id = 989
// module chunks = 1